import React, { useEffect, useState } from "react"
import { useTranslation } from "react-i18next"

import {
  VirtualList,
  Card,
  Checkbox,
  Tooltip,
  Spinner
} from "components"
import { getAllFoods } from "services"
import LsSearch from "./LsSearch"
import classes from "./LsFoods.module.scss"

const limit = 20

const initialFilterState = {
  search: ""
}

const LsFoods = props => {
  const {
    selectedFoods,
    setSelectedFoods,
    selectedCategory
  } = props

  const [t] = useTranslation()

  const [skip, setSkip] = useState(0)
  const [foods, setFoods] = useState(null)
  const [hasMore, setHasMore] = useState(true)
  const [filter, setFilter] = useState(initialFilterState)

  const handleSelectFood = (checked, food) => {
    setSelectedFoods(prev => {
      const previousFoodIds = { ...prev }

      if (checked) {
        previousFoodIds[food._id] = food
      } else {
        delete previousFoodIds[food._id]
      }

      return previousFoodIds
    })
  }

  const loadMore = async () => {
    const categoryIds =
      selectedCategory ? [selectedCategory] : []

    try {
      const response =
        await getAllFoods({
          skip,
          limit,
          categoryIds,
          ...filter
        })

      response.length !== limit
        ? setHasMore(false)
        : setSkip(prev => prev += limit)

      setFoods(prev => [...prev, ...response])
    } catch (err) {
      console.log(err)
    }
  }

  const getFoods = async () => {
    if (foods !== null) {
      setSkip(0)

      setHasMore(true)

      setFoods(null)
    }

    const categoryIds =
      selectedCategory ? [selectedCategory] : []

    try {
      const response =
        await getAllFoods({
          skip: 0,
          limit,
          categoryIds,
          ...filter
        })

      response.length !== limit
        ? setHasMore(false)
        : setSkip(prev => prev += limit)

      setFoods(response)
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getFoods()
  }, [filter, selectedCategory])

  return (
    <div className={classes["container"]}>
      <LsSearch
        delay={1200}
        placeholder={t("جست_و_جوی_کالا")}
        onSearch={(search) =>
          setFilter(prev => ({ ...prev, search }))
        }
      />

      {foods !== null
        ?
        <VirtualList
          keyField="_id"
          data={foods}
          itemHeight={60}
          className={classes["list"]}
          hasMore={hasMore}
          dataLength={skip}
          next={loadMore}
          loader={
            <div className={classes["loader"]}>
              <Spinner />
            </div>
          }
          listEmptyComponent={
            <div className={classes["no"]}>
              {t("هیچ_کالایی_یافت_نشد")}
            </div>
          }
          renderItem={(food) =>
            <Card className={classes["card"]}>
              <Tooltip title={food.name}>
                <span className={classes["food-name"]}>
                  {food.name}
                </span>
              </Tooltip>
              <Checkbox
                checked={!!selectedFoods[food._id]}
                onChange={(e) => handleSelectFood(e.target.checked, food)}
              />
            </Card>
          }
        />
        :
        <div className={classes["loading"]}>
          <Spinner />
        </div>
      }
    </div>
  )
}

export default LsFoods